import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { AccountType } from 'lumen/services/navigation';

export default class AccountSelectorSubscription extends Model {
  [Type] = 'account-selector-subscription' as const;

  @attr declare name: string;
  @attr declare type: AccountType;
}
